<template>
  <div>
    <div class="header-wrapper-exception superpro-banner">
      <h2>SuperPro</h2>
      <hr class="line" />
    </div>
    <b-container>
      <div class="grid">
        <div class="text">
          <p>
            SuperPro is an innovative Australian manufacturer of automotive
            polyurethane suspension bushings, control arms, swaybars and other
            suspension components for both 4x4 and performance vehicles.
          </p>
          <p>
            SuperPro is based in Brisbane, Queensland and does all engineering
            and manufacturing on site, ensuring the best quality product.
            Engineered to outperform, SuperPro's specially formulated and
            high-quality components are designed to create suspension solutions
            for better stability, handling and control in both on and off-road
            applications. SuperPro is supported by a full time, dedicated
            Research and Development Team with over 45 years of automotive
            industry experience in the toughest environments in Australia.
            SuperPro products are designed to be simple and effective, aiming to
            save time during the fitment process and give the most effective
            suspension solution.
          </p>
        </div>
        <div class="image">
          <picture>
            <source
              type="image/webp"
              srcset="./../../assets/brands-logos/superpro.png"
            />
            <img
              src="./../../assets/brands-logos/superpro.png"
              alt="Superpro"
            />
          </picture>
        </div>
      </div>
    </b-container>
    <page-header
      :text="$t('importantLinks')"
      font="black"
      back="white"
    ></page-header>
    <b-container>
      <div class="link-items">
        <router-link to="/catalogue/superpro">
          <div class="link-item">
            <v-icon left class="icon">mdi-play</v-icon>Catalogue ON-LINE
          </div>
        </router-link>
        <!-- <router-link to="/pricelist">
            <div class="link-item">
              <v-icon left class="icon">mdi-play</v-icon>{{ $t("pricelist") }}
            </div>
          </router-link> -->
        <a href="https://www.superpro.com.au/" target="_blank">
          <div class="link-item">
            <v-icon left class="icon">mdi-play</v-icon>Website
          </div>
        </a>
        <a
          href="https://www.youtube.com/@SuperProSuspensionParts"
          target="_blank"
        >
          <div class="link-item">
            <v-icon left class="icon">mdi-play</v-icon>Youtube Channel
          </div>
        </a>
      </div>
      <tire />
    </b-container>
  </div>
</template>

<script>
import PageHeader from "@/components/common/PageHeader.vue";
import Tire from "@/components/home/Tire";

import { mapGetters } from "vuex";

export default {
  name: "SuperProEn",
  components: { Tire, PageHeader },
  computed: {
    ...mapGetters(["isUserLogged"])
  }
};
</script>
